// The "Operate" (accounting) onboarding flow persists its in-progress answers in
// localStorage. Those keys are global, so without an owner check they would leak
// between accounts on the same browser. This guard wipes the stored answers when
// the logged-in account changes, so each account starts with its own blank info.

const OPERATE_KEYS = [
  'operateCompanyName',
  'operateWebsite',
  'operateFormationYear',
  'operateFormationEmirate',
  'operateEntityType',
  'operateTaxNumber',
  'operateIndustry',
  'operateDescription',
  'operatePlan',
  'operateOnboardingComplete',
];

export function ensureOperateOwner(): void {
  try {
    const userStr = localStorage.getItem('user');
    const uid = userStr ? JSON.parse(userStr)?.uid : null;
    if (!uid) return;
    if (localStorage.getItem('operateOwnerUid') !== uid) {
      OPERATE_KEYS.forEach(k => localStorage.removeItem(k));
      localStorage.setItem('operateOwnerUid', uid);
    }
  } catch { /* ignore malformed storage */ }
}
